import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** True if the string matches a canonical 8-4-4-4-12 UUID (server layer ids). */
export function isUuidString(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value
  );
}

/**
 * Converts Google Drive URLs to a viewable format that can be used in img tags.
 * Handles various Google Drive URL formats:
 * - https://drive.google.com/file/d/FILE_ID/view
 * - https://drive.google.com/file/d/FILE_ID
 * - https://drive.google.com/file/d/FILE_ID/edit
 * - https://drive.google.com/file/d/FILE_ID?usp=sharing
 *
 * Uses the thumbnail API which works better in browsers than export=view
 *
 * @param url - The Google Drive URL to convert
 * @returns The converted URL if it's a Google Drive URL, otherwise returns the original URL
 */
export function convertGoogleDriveUrl(url: string | undefined | null): string {
  if (!url) return url || '';

  // Check if it's a Google Drive URL
  if (url.includes('drive.google.com')) {
    // Extract file ID from various Google Drive URL formats
    const fileIdMatch = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (fileIdMatch) {
      const fileId = fileIdMatch[1];
      // Convert to thumbnail format which works better in browsers
      // sz=w1000 requests a width of 1000px, but can be adjusted
      return `https://drive.google.com/thumbnail?id=${fileId}&sz=w2000`;
    }
  }

  // Return original URL if not a Google Drive URL or if file ID couldn't be extracted
  return url;
}
